import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('TargetedRespondent')
export class TargetedRespondent {

    @JsonProperty('token',String,true)
    token = '';

    @JsonProperty('identifier',String,true)
    identifier = '';

    @JsonProperty('resp_id',Number,true)
    resp_id = 0;

    @JsonProperty('project_id',Number,true)
    project_id = 0;

    @JsonProperty('questionnaire_id',Number,true)
    questionnaire_id = 0;

    @JsonProperty('terminal_id',Number,true)
    terminal_id = 0;
}
